(() => {
  if (window.__igrInit) return;
  window.__igrInit = true;

  const toast = (msg) => {
    const t = document.createElement('div');
    t.className = 'igr-toast';
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(() => t.remove(), 2200);
  };

  const copy = async (text) => {
    try { await navigator.clipboard.writeText(text); toast('link copied'); }
    catch { window.prompt('Copy this link:', text); }
  };

  // Hide jump buttons whose target isn't on the page
  document.querySelectorAll('.igr-jump[data-hide-missing] [data-jump]').forEach((a) => {
    const id = decodeURIComponent(a.getAttribute('href').slice(1));
    if (!document.getElementById(id)) a.remove();
  });
  document.querySelectorAll('.igr-jump').forEach((nav) => {
    if (!nav.querySelector('[data-jump]')) nav.remove();
  });

  // Smooth scroll
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-jump]');
    if (!a) return;
    const el = document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1)));
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    history.replaceState(null, '', a.getAttribute('href'));
  });

  // Share + copy
  document.addEventListener('click', (e) => {
    const share = e.target.closest('.igr-share-trigger');
    if (share) {
      const data = { title: share.dataset.title, url: share.dataset.url };
      if (navigator.share) navigator.share(data).catch(() => {});
      else copy(data.url);
      return;
    }
    const c = e.target.closest('[data-copy-link]');
    if (c) copy(c.dataset.copyLink);
  });

  // Print recipe
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-print-recipe]')) return;
    document.body.classList.add('igr-printing');
    window.print();
    setTimeout(() => document.body.classList.remove('igr-printing'), 500);
  });

  // Servings scaler — scales the leading quantity of each ingredient line
  const FRACTIONS = { '¼': 0.25, '½': 0.5, '¾': 0.75, '⅓': 1 / 3, '⅔': 2 / 3, '⅛': 0.125 };
  const QTY = /^\s*(\d+\s+\d+\/\d+|\d+\/\d+|\d+(?:[.,]\d+)?\s*[¼½¾⅓⅔⅛]?|[¼½¾⅓⅔⅛])(\s*[-–]\s*(\d+(?:[.,]\d+)?|\d+\/\d+))?/;
  const parse = (s) => {
    s = s.trim().replace(',', '.');
    let n = 0;
    for (const [k, v] of Object.entries(FRACTIONS)) if (s.includes(k)) { n += v; s = s.replace(k, '').trim(); }
    if (!s) return n;
    if (s.includes(' ') && s.includes('/')) { const [w, f] = s.split(/\s+/); return n + +w + parse(f); }
    if (s.includes('/')) { const [a, b] = s.split('/'); return n + a / b; }
    return n + parseFloat(s);
  };
  const fmt = (n) => {
    const whole = Math.floor(n);
    const rest = n - whole;
    const nice = [[0, ''], [0.125, '⅛'], [0.25, '¼'], [1 / 3, '⅓'], [0.5, '½'], [2 / 3, '⅔'], [0.75, '¾'], [1, '']];
    let best = nice[0], diff = 1;
    for (const f of nice) { const d = Math.abs(rest - f[0]); if (d < diff) { diff = d; best = f; } }
    if (diff < 0.04) {
      const w = best[0] === 1 ? whole + 1 : whole;
      return (w ? w : '') + (best[1] && w ? ' ' : '') + best[1] || '0';
    }
    return (Math.round(n * 10) / 10).toString();
  };

  document.querySelectorAll('[data-recipe]').forEach((card) => {
    const base = parseInt(card.dataset.servings, 10);
    const out = card.querySelector('[data-servings-out]');
    if (!base || !out) return;
    const lines = [...card.querySelectorAll('[data-qty]')].map((el) => {
      const m = el.textContent.match(QTY);
      return { el, text: el.textContent, m };
    });
    let current = base;
    const render = () => {
      out.textContent = current;
      const r = current / base;
      lines.forEach(({ el, text, m }) => {
        if (!m) return;
        let q = fmt(parse(m[1]) * r);
        if (m[3]) q += '–' + fmt(parse(m[3]) * r);
        el.textContent = text.replace(m[0], (m[0].match(/^\s*/)[0]) + q);
      });
    };
    card.querySelectorAll('[data-scale]').forEach((btn) => btn.addEventListener('click', () => {
      current = Math.max(1, current + parseInt(btn.dataset.scale, 10));
      render();
    }));
  });
})();
